import { render, staticRenderFns } from "./GenericModifyPackage.vue?vue&type=template&id=6cc6dbb8&"
import script from "./GenericModifyPackage.vue?vue&type=script&lang=js&"
export * from "./GenericModifyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports